import { InstructionList } from '../containers/Instructions';
import { accessTypeEnum } from '../lib/enum';
export default [{
  component: InstructionList,
  path: '/instructions',
  access: Object.keys(accessTypeEnum)
}];
